/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_TitleInputs */

const en_us2_profile_editors_reminder_title = /** @type {(inputs: Profile_Editors_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What time should we remind you?`)
};

const pt_br2_profile_editors_reminder_title = /** @type {(inputs: Profile_Editors_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A que horas quer ser lembrado?`)
};

const es_419_profile_editors_reminder_title = /** @type {(inputs: Profile_Editors_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿A qué hora te lo recordamos?`)
};

const pt_pt2_profile_editors_reminder_title = /** @type {(inputs: Profile_Editors_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A que horas te lembramos?`)
};

const fr_fr2_profile_editors_reminder_title = /** @type {(inputs: Profile_Editors_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quelle heure te le rappeler ?`)
};

const de_de2_profile_editors_reminder_title = /** @type {(inputs: Profile_Editors_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann sollen wir dich erinnern?`)
};

const it_it2_profile_editors_reminder_title = /** @type {(inputs: Profile_Editors_Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A che ora vuoi il promemoria?`)
};

/**
* | output |
* | --- |
* | "What time should we remind you?" |
*
* @param {Profile_Editors_Reminder_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_title = /** @type {((inputs?: Profile_Editors_Reminder_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_title(inputs)
	return en_us2_profile_editors_reminder_title(inputs)
});
export { profile_editors_reminder_title as "profile-editors.reminder_title" }